import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { RecalProcessAndGenEditCriteria } from "domain/entity/Recalculation/RecalProcessAndGenEditCriteria";
import { RecalProcessAndGenEntity } from "domain/entity/Recalculation/RecalProcessAndGenEntity";
import { RecalProcessAndGenGenerateCriteria } from "domain/entity/Recalculation/RecalProcessAndGenGenerateCriteria";
import { RecalProcessAndGenSearchCriteria } from "domain/entity/Recalculation/RecalProcessAndGenSearchCriteria";
import { RecalProcessAndGenSubmitEntity } from "domain/entity/Recalculation/RecalProcessAndGenSubmitEntity";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import recalAxiosInstance from "../axios/recalAxiosInstance";
import { RecalProcessAndGenRepository } from "./RecalProcessAndGenRepo";

export const RecalProcessAndGenRepoImpl = (): RecalProcessAndGenRepository => {

    const recalculationSubmit = async (rows: RecalProcessAndGenSubmitEntity[]): Promise<ResponseEntity> => {
        const url = '/v1/recalProcessAndGenSubmit'
        return await axiosPostData(recalAxiosInstance, url, rows);
    }

    const recalculationGenerate = async (criteria: RecalProcessAndGenGenerateCriteria): Promise<ResponseEntity> => {
        const url = '/v1/recalProcessAndGenGenerate'
        return await axiosPostData(recalAxiosInstance, url, criteria);
    }

    const onSearch = async (searchCriteria: RecalProcessAndGenSearchCriteria): Promise<RecalProcessAndGenEntity[]> => {
        const url = '/v1/recalProcessAndGenSearch'
        return axiosPostData(recalAxiosInstance, url, searchCriteria).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const recalculationDelete = async (rows: RecalProcessAndGenEntity[]): Promise<ResponseEntity> => {
        const url = '/v1/recalProcessAndGenDelete';
        return await axiosPostData(recalAxiosInstance, url, rows);
    }

    const onSave = async (criteria: RecalProcessAndGenEditCriteria): Promise<ResponseEntity> => {
        const url = '/v1/recalProcessAndGenSave';
        return await axiosPostData(recalAxiosInstance, url, criteria);
    }

    return {
        recalculationSubmit: recalculationSubmit,
        recalculationGenerate: recalculationGenerate,
        onSearch: onSearch,
        recalculationDelete: recalculationDelete,
        onSave: onSave,
    }
}